import  { createContext } from 'react';
import { TranslationAction, TranslationState } from '../types';

interface ContextProps {
  state: TranslationState;
  dispatch: (action: TranslationAction) => void;
}

export const TranslationContext = createContext({} as ContextProps);
